import React from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import ExpenseHeadTable from "./ExpenseHeadTable";
import ExpensePurposeTable from "./ExpensePurposeTable";

type Props = {};

const ExpenseScreen = (props: Props) => {
  return (
    <div className="p-2">
        <PageHeader title="Expense Head" />
         
         <div>
          <ExpenseHeadTable />
         </div>
         <div style={{marginTop:20}}>
          <ExpensePurposeTable />
         </div>
    </div>
  );
};

export default ExpenseScreen;
